import { render, staticRenderFns } from "./address.vue?vue&type=template&id=02472b8a&scoped=true"
import script from "./address.vue?vue&type=script&lang=js"
export * from "./address.vue?vue&type=script&lang=js"
import style0 from "./address.vue?vue&type=style&index=0&id=02472b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02472b8a",
  null
  
)

export default component.exports